import { delay } from "@features/FxLauncherLoader/utils/helpers";

export async function killProcess(processIdToKill: number) {
	if (processIdToKill == -1) {
		console.log("killProcess called with invalid process id");
		return;
	}
	console.log(`process ${processIdToKill} must be running, lets kill it first `);
	while (true) {
		try {
			//  no-await-in-loop
			const terminateResult = await FxApi.Process.terminateProcess(processIdToKill, 10000);
			console.log(`terminateResult ${terminateResult}`);
		} catch (error) {
			console.log(" await FxApi.Process.terminateProcess(processIdToKill, 10000);", error);
		}

		const processes = await FxApi.Process.listProcesses();
		const process = processes.find((processCandidate) => processCandidate.id === processIdToKill);
		if (!process) {
			console.log(`process ${processIdToKill} killed, we can continue`);
			break;
		} else {
			console.log(`process ${processIdToKill} still present, waiting `);

			await delay(1000);
		}
	}
}
